// servicios/inventarios/application/obtenerInventarioInicial.usecase.js
import { obtenerMovimientoInventario } from "../infrastructure/supabase/inventarioMovimiento.repository.js";
 

export async function obtenerMovimientoInventarioUseCase(filtros = {}) {

  console.log(" [obtenerMovimientoInventarioUseCase] Iniciando consulta", filtros);

  try {

    const data = await obtenerMovimientoInventario(filtros);

    console.log(
      "[obtenerMovimientoInventarioUseCase] Respuesta del repositorio:",
      data
    );

    if (!Array.isArray(data)) {
      console.warn(
        "[obtenerMovimientoInventarioUseCase] La respuesta no es un array:",
        data
      );
      return [];
    }

    console.log(
      "[obtenerMovimientoInventarioUseCase] Datos recibidos correctamente",
      {
        cantidad: data.length,
        muestra: data.slice(0, 3)
      }
    );

    return data;

  } catch (error) {

    console.error(
      "❌ [obtenerMovimientoInventarioUseCase] Error en servicio:",
      error?.message,
      error
    );

    return [];

  } finally {

    console.log(
      "🏁 [obtenerMovimientoInventarioUseCase] Finalizó ejecución"
    );

  }
}